<template>
  <el-form v-loading="isLoading" element-loading-background="rgba(24, 33, 48, 0.8)" ref="ruleForm" :model="form" :rules="rules">
    <div class="box-body">
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col">
          <el-form-item label="Internal code (#pi)" prop="id">
            <el-input
              v-model="form.id"
              placeholder="System Generated ID"
              disabled
            >
              <template #prepend>
                <i class="fa fa-id-badge fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="Internal code (#pi)" prop="pi">
            <el-input v-model="form.pi" placeholder="Input Internal code (#pi)">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="Barcode (#pc)" prop="pc">
            <el-input v-model="form.pc" placeholder="Input Barcode (#pc)">
              <template #prepend>
                <i class="fa fa-barcode fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="Product name (#pn)" prop="pn">
            <el-input v-model="form.pn" placeholder="Input Product name (#pn)">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="Specification (#ps)" prop="ps">
            <el-input v-model="form.ps" placeholder="Input Specification (#ps)">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="Grade (#pg)" prop="pg">
            <el-input v-model="form.pg" placeholder="Input Grade (#pg)">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="Unit (#pu)" prop="pu">
            <el-input v-model="form.pu" placeholder="Input Unit (#pu)">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="Price (#pp)" prop="pp">
            <el-input-number
              v-model="form.pp"
              :precision="2"
              placeholder="Input Price (#pp)"
              class="w-full"
            >
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input-number>
          </el-form-item>

          <el-form-item label="Discount Price (#vp)" prop="vp">
            <el-input-number
              v-model="form.vp"
              :precision="2"
              placeholder="Input Discount Price (#vp)"
              class="w-full"
            >
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input-number>
          </el-form-item>

          <el-form-item label="Original Price (#pop)" prop="pop">
            <el-input-number
              v-model="form.pop"
              :precision="2"
              placeholder="Input Original Price (#pop)"
              class="w-full"
            >
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input-number>
          </el-form-item>

          <el-form-item label="Origin (#po)" prop="po">
            <el-input v-model="form.po" placeholder="Input Origin (#po)">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="MFRS (#pm)" prop="pm">
            <el-input v-model="form.pm" placeholder="Input MFRS (#pm)">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <span class="el-form-item__label flex flex-row items-center gap-2">
            <span class="flex flex-row items-center gap-2">
              Scene (#promotion)
              <el-tooltip
                content="Match the Scene in the esl template"
                placement="top"
              >
                <i class="fa fa-info-circle cursor-pointer"></i>
              </el-tooltip>
            </span>
          </span>
          <el-form-item label="" prop="promotion">
            <el-select
              v-model="form.promotion"
              placeholder="Select Scene"
              style="width: 100%"
              clearable
              filterable
              :filter-method="filterPromotion"
            >
              <el-option label="Normal" :value="1" />
              <el-option label="Vip" :value="2" />
              <el-option label="Promotion" :value="3" />
              <el-option label="Inventory" :value="4" />
              <el-option label="Limit" :value="5" />
              <el-option label="None" :value="6" />
              <el-option label="Off" :value="7" />
            </el-select>
          </el-form-item>

          <el-divider />

          <el-form-item label="QR Code Url (#pqr)" prop="pqr">
            <el-input v-model="form.pqr" placeholder="Input QR Code Url (#pqr)">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="Stock (#kc)" prop="kc">
            <el-input-number
              v-model="form.kc"
              :min="0"
              :step="1"
              placeholder="Input Stock (#kc)"
              class="w-full"
            />
          </el-form-item>

          <el-form-item label="Desc" prop="desc">
            <el-input
              v-model="form.desc"
              type="textarea"
              rows="4"
              placeholder="Input Desc"
              class="product_desc"
            />
          </el-form-item>

          <el-form-item label="Images (#pim)" prop="pim">
            <el-input v-model="form.pim" placeholder="Input Images (#pim)">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="ImagesID" prop="imagesId">
            <el-input v-model="form.imagesId" placeholder="Input ImagesID">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="Video" prop="video">
            <el-input v-model="form.video" placeholder="Input Video">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="VideoID" prop="videoId">
            <el-input v-model="form.videoId" placeholder="Input VideoID">
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>
        </div>
        <div class="flex flex-col">
          <el-form-item
            v-for="n of 16"
            :key="String(n)"
            :label="`Customize${n} (#f${n})`"
          >
            <el-input
              v-model="form[`f${n}`]"
              :placeholder="`Input Customize${n} (#f${n})`"
              autocomplete="off"
            >
              <template #prepend>
                <i class="fa fa-pencil fa-fw"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-divider />

          <el-form-item label="Expand(#exxx)">
            <div class="flex flex-col gap-2 w-full">
              <div class="flex flex-row w-full">
                <div class="flex-1">Key</div>
                <div class="flex-1">Value</div>
                <div class="w-10"></div>
              </div>
              <div
                class="flex flex-row w-full gap-2 mb-2"
                v-for="(item, idx) in extendFieldsList"
                :key="item.uuid"
              >
                <el-input
                  class="flex-1"
                  placeholder="Input Key"
                  v-model="item.key"
                />
                <el-input
                  class="flex-1"
                  placeholder="Input Value"
                  v-model="item.value"
                />
                <el-button
                  class="w-[120px]"
                  type="danger"
                  icon="el-icon-delete"
                  @click="removeExtendItem(idx)"
                >
                  Remove
                </el-button>
              </div>
              <div class="flex flex-row gap-2 w-full">
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  class="flex-1"
                  @click="addExtendItem()"
                >
                  Add
                </el-button>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="flex flex-row p-4 justify-end gap-4">
      <el-button @click="$emit('cancel')">Cancel</el-button>
      <el-button :loading="isSubmitting" type="primary" @click="handleSubmit">
        Submit
      </el-button>
    </div>
  </el-form>
</template>
<script>
import { EslProductModel } from "@/api";
import { v4 as uuid } from "uuid";
import { createEslProduct,getEslProductDetailByCode } from "../../api";

export default {
  name: "EditProduct",
  props: {
    productCode: {
      type: String,
      default: () => "",
    },
  },
  data() {
    const form = new EslProductModel();
    let extendFieldsList = [];
    return {
      form,
      extendFieldsList,
      isSubmitting: false,
      isLoading: false,
      rules: {
        pc: [
          { required: true, message: "Barcode is required", trigger: "blur" },
        ],
        pn: [
          {
            required: true,
            message: "Product name is required",
            trigger: "blur",
          },
        ],
        pp: [{ required: true, message: "Price is required", trigger: "blur" }],
      },
    };
  },
  computed: {
    extendsFields: {
      get() {
        // Add uuid to each item for v-for key
        return Object.entries(this.form.extend || {}).map(([key, value]) => {
          // If value is an object with {value, uuid}, use it, else wrap
          if (
            value &&
            typeof value === "object" &&
            Object.prototype.hasOwnProperty.call(value, "value") &&
            Object.prototype.hasOwnProperty.call(value, "uuid")
          ) {
            return { key, value: value.value, uuid: value.uuid };
          }
          // fallback: generate uuid for legacy data
          return { key, value, uuid: uuid() };
        });
      },
      set(value) {
        // value is an array of {key, value, uuid}
        const obj = {};
        value.forEach(({ key, value, uuid }) => {
          if (key) obj[key] = { value, uuid };
        });
        this.form.extend = obj;
      },
    },
  },
  methods: {
    async fetchProductSingle() {
      this.isLoading = true;
      try {
        const productData = await getEslProductDetailByCode(this.productCode);
        this.form = new EslProductModel(productData);
        // Rebuild extendFieldsList
        this.extendFieldsList = [];
        if (this.form.extend && typeof this.form.extend === "object") {
          this.extendFieldsList = Object.entries(this.form.extend).map(
            ([key, value]) => {
              if (
                value &&
                typeof value === "object" &&
                Object.prototype.hasOwnProperty.call(value, "value") &&
                Object.prototype.hasOwnProperty.call(value, "uuid")
              ) {
                return { key, value: value.value, uuid: value.uuid };
              }
              return { key, value, uuid: uuid() };
            }
          );
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
      } finally {
        this.isLoading = false;
      }
    },
    filterPromotion(query, option) {
      return option.label.toLowerCase().includes(query.toLowerCase());
    },
    removeExtendItem(idx) {
      this.extendFieldsList.splice(idx, 1);
      this.syncExtendToForm();
    },
    addExtendItem() {
      this.extendFieldsList.push({ key: "", value: "", uuid: uuid() });
      this.syncExtendToForm();
    },
    syncExtendToForm() {
      const obj = {};
      this.extendFieldsList.forEach(({ key, value, uuid }) => {
        if (key) obj[key] = { value, uuid };
      });
      this.form.extend = obj;
    },
    async handleSubmit() {
      if (this.isSubmitting) return;
      await this.$refs.ruleForm.validate();
      try {
        this.isSubmitting = true;
        this.syncExtendToForm();
        await createEslProduct(this.form);
        this.$emit("confirm", this.form);
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  async mounted() {
    if (this.productCode) {
      await this.fetchProductSingle();
    }
  },
};
</script>
